module.exports = __webpack_public_path__ + "img/icon-down.a2018c5c.png";